import { render, staticRenderFns } from "./indexTemp.vue?vue&type=template&id=636bd2c2"
import script from "./indexTemp.vue?vue&type=script&lang=js"
export * from "./indexTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports